module.exports = __webpack_public_path__ + "img/gmm.d510f9ef.svg";